import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { ServiceService } from "../chargeser.service";
import { SimpleChanges } from "@angular/core";

declare var bootstrap: any;
declare var $: any;

@Component({
  selector: "app-preferences",
  templateUrl: "./preferences.component.html",
  styleUrls: ["./preferences.component.css"],
})
export class Preferences implements OnInit {
  @Input() pref: any;
  @Input() filteredTag: any;
  @Input() monthYear: any;
  @Input() accountId: any; // now Angular tracks this too
  @Input() selectedView: any;
  @Output() close = new EventEmitter<void>();
  @Output() responseToParent = new EventEmitter<any>();
  @Output() pageSizeChange = new EventEmitter<number>();
  selectedAccountIds: string[] = [];

  visibleColumns = {
    description: true,
    usageQuantity: true,
    amountUsd: true,
    region: true,
    tagName: true,
  };

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };

  currentPage = 1;
  pageSizeOptions = [20, 50, 100];
  selectedPageSize = 20;
  wrapLines = false;
  usagePagination = false;

  accountOptions: any[] = [];
  isExpandedAll = false;
  all_account_cost_summary: any;
  accounts: any[] = [];
  total: any;
  isChargeMode: boolean;

  constructor(
    private apiServer: APIService,
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService
  ) {}

  ngOnInit(): void {
    if (this.pref) {
      this.patchPreferences(this.pref);

      setTimeout(() => {
        $(".selectpicker").selectpicker("refresh");
      }, 0);
    }
    const currentQuery = this.route.snapshot.queryParams;
    const hasOpenParam = "open" in currentQuery;
    this.isChargeMode = currentQuery["open"] === "chargeacc";
  }
breakpointsChanged:any;
  onSubmitClick(): void {
     this.breakpointsChanged = !this.objectsAreEqual(
      this.breakpoints,
      this.pref.breakpoints
    );
        console.log(this.selectedView);

    if (!this.filteredTag && this.breakpointsChanged && this.selectedView == 'monthly') {
      this.onAnyPreferenceChange();
    } else {
      
      this.emitPreferences();
    }
  }

  onPageSizeChangeFromModal() {
    console.log("items per page changed", this.selectedPageSize);
    this.pageSizeChange.emit(this.selectedPageSize); // 👈 emit the new value
  }

  clearPreferences(): void {
    this.selectedPageSize = 20;
    this.wrapLines = false;
    this.usagePagination = false;
    this.visibleColumns = {
      description: true,
      usageQuantity: true,
      amountUsd: true,
      region: true,
      tagName: true,
    };
    this.close.emit();
  }

  private onAnyPreferenceChange(): void {
    const activeBreakpoints = Object.keys(this.breakpoints)
      .filter((key) => this.breakpoints[key as keyof typeof this.breakpoints])
      .map((key) => key);

      if(this.selectedView !== 'monthly'){
    if (activeBreakpoints.length === 0) {
      this.break_points();
    } else {
      this.break_points(activeBreakpoints);
    }
      }
      else{
        this.emitPreferences()
      }

  }

  private emitPreferences(): void {
    this.responseToParent.emit({
      preferences: {
        pageSize: this.selectedPageSize,
        wrapLines: this.wrapLines,
        usagePagination: this.usagePagination,
        visibleColumns: { ...this.visibleColumns },
        breakpoints: { ...this.breakpoints },
        selectedAccountIds: [...this.selectedAccountIds],
        breakpointsChanged: this.breakpointsChanged
      },
    });
  }

  private patchPreferences(pref: any): void {
    this.selectedPageSize = pref.pageSize;
    this.wrapLines = pref.wrapLines;
    this.usagePagination = pref.usagePagination;
    this.visibleColumns = { ...pref.visibleColumns };
    this.breakpoints = { ...pref.breakpoints };
    this.selectedAccountIds = [...pref.selectedAccountIds];
  }

  private objectsAreEqual(obj1: any, obj2: any): boolean {
    if (!obj1 && !obj2) return true;
    if (!obj1 || !obj2) return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    return keys1.every((k) => obj1[k] === obj2[k]);
  }

  async break_points(activeBreakpoints?: string[]): Promise<void> {
    this.notifier.loading(true);
    this.isExpandedAll = false;

    const currentQuery = this.route.snapshot.queryParams;
    const hasOpenParam = "open" in currentQuery;
    const isChargeAccMode = currentQuery["open"] === "chargeacc";
    const isTParamMode = "_t" in currentQuery;

    let accountIdsParam: string | string[];

    if (isChargeAccMode) {
      const stored = localStorage.getItem("accountIdData");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          const list = parsed.list || [];

          this.accountOptions = list.map((item: any) => ({
            id: item.accountId,
            name: `${item.accountName} (${item.accountId})`,
          }));

          accountIdsParam = list.map((item: any) => item.accountId);
        } catch (e) {
          console.error("Error parsing accountIdData from localStorage", e);
          accountIdsParam = this.accountId;
        }
      } else {
        accountIdsParam = this.accountId;
      }
    } else {
      accountIdsParam =
        this.selectedAccountIds.length > 1
          ? this.selectedAccountIds.join(",")
          : this.accountId;
    }

    const cleanedParams: any = { ...currentQuery };
    delete cleanedParams.open;
    delete cleanedParams._t;
    delete cleanedParams.mode;

    const [month, year] = this.monthYear.split("-");
    cleanedParams.account_ids = accountIdsParam;
    cleanedParams.year = year;
    cleanedParams.month = month;

    if (activeBreakpoints?.length) {
      cleanedParams.breakup = activeBreakpoints.join(",");
    } else {
      delete cleanedParams.breakup;
    }

    try {
      const { result, fullQuery } = await this.service.loadData(cleanedParams);
      const allCostSummary = result?.response?.aws[0].current_month;
      const accounts = result?.response?.accounts?.current_month ?? [];
      let responseData: any;

      if (isChargeAccMode) {
        this.total = allCostSummary?.total_unblended_cost ?? 0;

        this.accounts = accounts.map((acc: any) => ({
          ...acc,
          expanded: false,
          services: (acc.services ?? []).map((s: any) => ({
            ...s,
            expanded: false,
          })),
        }));

        const totalServices = accounts.reduce(
          (sum: any, acc: any) => sum + (acc.total_services ?? 0),
          0
        );
        responseData = {
          total_accounts: allCostSummary?.total_accounts ?? accounts.length,
          total_services: totalServices,
          accounts,
          preferences: {
            mode: "chargeacc",
            pageSize: this.selectedPageSize,
            wrapLines: this.wrapLines,
            usagePagination: this.usagePagination,
            visibleColumns: { ...this.visibleColumns },
            breakpoints: { ...this.breakpoints },
            selectedAccountIds: accountIdsParam,
          },
        };
      } else {
        this.all_account_cost_summary = allCostSummary;
        responseData = {
          total_services: accounts[0]?.total_services || 0,
          services: accounts[0]?.services || [],
          preferences: {
            pageSize: this.selectedPageSize,
            wrapLines: this.wrapLines,
            usagePagination: this.usagePagination,
            visibleColumns: { ...this.visibleColumns },
            breakpoints: { ...this.breakpoints },
            selectedAccountIds: [...this.selectedAccountIds],
            mode: isTParamMode ? "_t" : "default",
          },
        };
      }

      /* -------------------------------------------------------------------
       * 4. Build NAV params — remove `breakup` + `mode` if no breakpoints
       * ----------------------------------------------------------------- */
      const includeBreakups = !!activeBreakpoints?.length;

      // helper: Angular removes params whose value is null
      const maybeBreakup = includeBreakups ? activeBreakpoints.join(",") : null;
      const maybeMode = includeBreakups ? "preferences" : null;

      // convert the raw service URL back into an object (unchanged logic)
      const queryParamsObj: any = {};
      fullQuery.split("&").forEach((kv: string) => {
        const [k, v] = kv.split("=");
        if (!(hasOpenParam && k === "account_ids")) queryParamsObj[k] = v;
      });

      const navParams = hasOpenParam
        ? {
            year,
            month,
            breakup: maybeBreakup,
            mode: maybeMode,
          }
        : {
            ...queryParamsObj,
            account_ids: accountIdsParam,
            breakup: maybeBreakup,
            mode: maybeMode,
          };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: navParams,
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
      console.log('resp in break',responseData);
      this.responseToParent.emit(responseData);

      const modalEl = document.getElementById("preferencesModal");
      if (modalEl) bootstrap.Modal.getInstance(modalEl)?.hide();
    } catch (err) {
      console.error("Breakpoints load error:", err);

      this.responseToParent.emit({
        total_services: 0,
        services: [],
        preferences: {},
      });
    } finally {
      this.notifier.loading(false);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["pref"] && !changes["pref"].firstChange) {
      this.patchPreferences(changes["pref"].currentValue);
    }

    if (changes["monthYear"] && !changes["monthYear"].firstChange) {
      console.log("Updated monthYear:", this.monthYear);
    }

    if (changes["filteredTag"] && !changes["filteredTag"].firstChange) {
      console.log("Updated filteredTag:", this.filteredTag);
    }
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();
  }
}
